module.exports = __webpack_public_path__ + "static/1_pay-e443279640aab62f1a620e86ba26165b.png";